import { render, staticRenderFns } from "./consumptionCoupons.vue?vue&type=template&id=28b50ece&scoped=true&"
import script from "./consumptionCoupons.vue?vue&type=script&lang=js&"
export * from "./consumptionCoupons.vue?vue&type=script&lang=js&"
import style0 from "./consumptionCoupons.vue?vue&type=style&index=0&id=28b50ece&prod&lang=scss&"
import style1 from "./consumptionCoupons.vue?vue&type=style&index=1&id=28b50ece&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b50ece",
  null
  
)

export default component.exports